module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (15).71e1e7ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (15).jpg
// module id = 337
// module chunks = 0